export const useSmartBannerPosition = () => {
    const hasSmartbanner = $("html").hasClass("has-smartbanner");
    const hasNotification = $("body").hasClass("has-notification");
    const smartBannerHeight = hasSmartbanner ? 84 : 0;
    const notificationHeight = hasNotification ? 64 : 0;

    return {
        hasSmartbanner,
        hasNotification,
        smartBannerHeight,
        notificationHeight,
    };
};
